export interface PlatformDto {
  id: string;
  name: string;
  shortName: string;
  emoji: string;
  description: string;
  playUrl: string;
}

export type AuthMode = 'none' | 'otp' | 'token';

export interface ConfigDto {
  publicBaseUrl: string;
  playBaseUrl: string;
  accessRequired: boolean;
  authMode: AuthMode;
  platforms: PlatformDto[];
}

export interface StatusDto {
  upstreams: Record<string, { url: string; status: 'online' | 'offline' }>;
  platforms: Array<{ id: string; status: 'online' | 'offline' }>;
}

const TOKEN_KEY = 'games_access_token';

export function getStoredToken(): string {
  return sessionStorage.getItem(TOKEN_KEY) || '';
}

export function storeToken(token: string): void {
  sessionStorage.setItem(TOKEN_KEY, token);
}

export function clearToken(): void {
  sessionStorage.removeItem(TOKEN_KEY);
}

function authHeaders(): HeadersInit {
  const token = getStoredToken();
  return token ? { Authorization: `Bearer ${token}` } : {};
}

async function parseJson<T>(res: Response): Promise<T> {
  const data = (await res.json().catch(() => ({}))) as T & { error?: string };
  if (!res.ok) throw new Error(data.error || `Erro ${res.status}`);
  return data;
}

async function apiFetch<T>(path: string, init?: RequestInit): Promise<T> {
  const res = await fetch(path, {
    ...init,
    headers: {
      'Content-Type': 'application/json',
      ...authHeaders(),
      ...(init?.headers || {}),
    },
    credentials: 'include',
  });
  if (res.status === 401) throw new Error('UNAUTHORIZED');
  return parseJson<T>(res);
}

export const api = {
  config: () => apiFetch<ConfigDto>('/api/config'),
  status: () => apiFetch<StatusDto>('/api/status'),
  sendOtp: (email: string) =>
    apiFetch<{ success: boolean; message?: string; mock?: boolean }>('/api/auth/send-otp', {
      method: 'POST',
      body: JSON.stringify({ email }),
    }),
  verifyOtp: (email: string, code: string) =>
    apiFetch<{ success: boolean; token: string; email: string }>('/api/auth/verify', {
      method: 'POST',
      body: JSON.stringify({ email, code }),
    }),
  logout: () => apiFetch<{ success: boolean }>('/api/auth/logout', { method: 'POST' }),
};
